.header {
  display: flex;
  justify-content: space-between;
  gap: var(--spacingMd);
  width: 100%;

  .actionIcons {
    display: flex;
    align-items: flex-start;
    gap: var(--spacingMd);
  }
}

.headerWithChildren {
  display: grid;
  column-gap: var(--spacingMd);
  grid-template-columns: auto 1fr auto;
  width: 100%;

  .children {
    display: flex;
    align-items: center;
  }
}

.headerContainer {
  text-align: left;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-grow: 2;
  min-width: 0;
}

.title {
  max-width: 270px;
}

.titleLabel {
  max-width: 270px;
  color: var(--paletteBlue2);
}
